export const audioQueryConstraints = {
	autoGainControl: true,
	echoCancellation: true,
	noiseSuppression: true,
	sampleRate: 48000
};

export const videoQueryConstraints = {
	frameRate: 30,
	height: 720,
	width: 1280
};
